<template>
  <div class="list-table">
    <v-container fluid grid-list-xl>
      <v-layout row wrap v-if="role === 'GEM'">
        <v-flex md6 xs12>
          <v-select
            :items="laboratories"
            label="Filtrar por Laboratorio: "
            no-data-text="Datos no disponibles"
            v-on:change="reloadGraphics"
            v-model="labId"
            clearable
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12 v-if="barCreatedDelivered">
          <v-widget content-bg="white" title="Creadas vs Entregadas">
            <div slot="widget-content">
              <e-chart
                :path-option="[
                  ['dataset.source', barCreatedDelivered],
                  ['color', ['#E6C57D', '#81B5DE']],
                  ['legend.show', true],
                  ['xAxis.axisLabel.show', true],
                  ['yAxis.axisLabel.show', true],

                  ['series[0].type', 'bar'],
                  ['series[0].areaStyle', {}],
                  ['series[0].smooth', true],
                  ['series[1].type', 'bar'],
                  ['series[1].areaStyle', {}],
                  ['series[1].smooth', true],
                ]"
                width="90%"
              ></e-chart>
            </div>
          </v-widget>
        </v-flex>

        <v-flex lg12 sm12 xs12 v-if="barInvoices">
          <v-widget
            content-bg="white"
            title="Pendientes / Rechazadas / Aprobadas"
          >
            <div slot="widget-content">
              <e-chart
                :path-option="[
                  ['dataset.source', barInvoices],
                  ['color', ['#B5B5BA', '#bd614d', '#E6C57D']],
                  ['legend.show', true],
                  ['xAxis.axisLabel.show', true],
                  ['yAxis.axisLabel.show', true],

                  ['series[0].type', 'bar'],
                  ['series[0].areaStyle', {}],
                  ['series[0].smooth', true],
                  ['series[1].type', 'bar'],
                  ['series[1].areaStyle', {}],
                  ['series[1].smooth', true],
                  ['series[2].type', 'bar'],
                  ['series[2].areaStyle', {}],
                  ['series[2].smooth', true],
                ]"
                width="90%"
              ></e-chart>
            </div>
          </v-widget>
        </v-flex>

        <v-flex lg6 sm12 xs12 v-if="pieCreatedDelivered">
          <v-widget title="Creadas vs Aprobadas">
            <div slot="widget-content">
              <e-chart
                :path-option="[
                  ['dataset.source', pieCreatedDelivered],
                  ['color', ['#81B5DE', '#bd614d']],
                  ['legend.orient', 'horizontal'],
                  ['legend.y', 'bottom'],
                  ['xAxis.show', false],
                  ['yAxis.show', false],
                  ['series[0].type', 'pie'],
                ]"
                width="90%"
              ></e-chart>
            </div>
          </v-widget>
        </v-flex>

        <v-flex lg6 sm12 xs12 v-if="pieRegularVariation">
          <v-widget title="Regular vs Desviaciones">
            <div slot="widget-content">
              <e-chart
                :path-option="[
                  ['dataset.source', pieRegularVariation],
                  ['color', ['#81B5DE', '#bd614d']],
                  ['legend.orient', 'horizontal'],
                  ['legend.y', 'bottom'],
                  ['xAxis.show', false],
                  ['yAxis.show', false],
                  ['series[0].type', 'pie'],
                ]"
                width="90%"
              ></e-chart>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog max-width="350" persistent v-model="loading">
      <loading></loading>
    </v-dialog>
  </div>
</template>
<script>
import EChart from '@/components/chart/echart'
import VWidget from '@/components/VWidget'
import SessionHelper from '@/helpers/SessionHelper'
const shortMonth = [
  'Ene',
  'Feb',
  'Mar',
  'Abr',
  'May',
  'Jun',
  'Jul',
  'Ago',
  'Sep',
  'Oct',
  'Nov',
  'Dic',
]
import loading from './dialog/DialogLoading'
export default {
  components: {
    loading,
    VWidget,
    EChart,
  },

  data() {
    return {
      laboratories: [],
      loading: true,
      labId: null,
      role: null,
      barInvoices: null,
      barCreatedDelivered: null,
      pieCreatedDelivered: null,
      pieRegularVariation: null,
    }
  },
  created() {
    this.$store.dispatch('laboratories/getAll', {}).then(response => {
      const data = response.items
      for (let index = 0; index < data.length; index += 1) {
        this.laboratories.push({
          text: data[index].name,
          value: data[index].id,
        })
      }
    })

    this.reloadGraphics()
  },
  methods: {
    reloadGraphics() {
      this.barInvoices = null
      this.barCreatedDelivered = null
      this.pieRegularVariation = null
      this.pieCreatedDelivered = null
      this.loading = true
      this.role = SessionHelper.role
      let params = {}
      if (this.labId) {
        params.labId = this.labId
      }
      this.getPieRegularVariation(params)
      this.getPieCreateDelivered(params)
      this.getBarCreateDelivered(params)
      this.getBarInvoices(params)
      setTimeout(() => {
        this.loading = false
      }, 1500)
    },
    getPieRegularVariation(params) {
      this.$store
        .dispatch('dashboard/getPieRegularVariation', params)
        .then(response => {
          this.pieRegularVariation = response.data
        })
    },
    getPieCreateDelivered(params) {
      this.$store
        .dispatch('dashboard/getPieCreateDelivered', params)
        .then(response => {
          this.pieCreatedDelivered = response.data
        })
    },
    getBarCreateDelivered(params) {
      this.$store
        .dispatch('dashboard/getBarCreateDelivered', params)
        .then(response => {
          this.barCreatedDelivered = shortMonth.map((m, index) => {
            return {
              month: m,
              Creadas: response.data.pending[index],
              Entregadas: response.data.delivered[index],
            }
          })
        })
    },
    getBarInvoices(params) {
      this.$store
        .dispatch('dashboard/getBarInvoices', params)
        .then(response => {
          this.barInvoices = shortMonth.map((m, index) => {
            return {
              month: m,
              Pendientes: response.data.pending[index],
              Rechazadas: response.data.denied[index],
              Aprobadas: response.data.approved[index],
            }
          })
        })
    },
  },
}
</script>
